import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/material/integrations/nextjs/nextjs.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
